
import respUtility from '@/mixins/respUtility';
// eslint-disable-next-line import/no-extraneous-dependencies
import VClamp from 'vue-clamp';

export default {
  name: 'BrandBannerDesc',
  mixins: [respUtility],
  props: {
    description: {
      type: String,
      default: '',
    },
    isCollectionPage: {
      type: Boolean,
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    fullText() {
      return this.description;
    },
    textContent() {
      if (process.server) {
        return this.fullText;
      }
      const element = document.createElement('div');
      element.innerHTML = this.description;
      const plainText = element.textContent || element.innerText || '';
      return plainText;
    },
  },
  methods: {
    toggleReadMore() {
      this.isExpanded = !this.isExpanded;
    },
  },
  components: { VClamp },
};
